<template>
  <DotsRLmobile v-if="reverse" />
  <DotsLRmobile v-else />
</template>

<script setup lang="ts">
import DotsLRmobile from './Icons/DotsLRmobile.vue'
import DotsRLmobile from './Icons/DotsRLmobile.vue'
defineProps({
  reverse: { type: Boolean, default: false },
})
</script>
